import {createContext, Dispatch, FC, Reducer, useReducer} from "react";
import { DynamicsProject, IGraphUser, IUnit, Settings } from "../types/ApiTypes";
import { IWorkAtProject } from "../types/interfaces/IWorkAtProject";

const initialData: State = {
    roles: [],
    user: [],
    units: {
        main: [],
        secondary: []
    },
    settings: {
        approvalTool: 'integrated'
    },
    projects: []
};

interface State {
    roles: string[],
    user: IGraphUser[],
    units: {
        main: IUnit[],
        secondary: IUnit[]
    },
    settings: Settings,
    projects: IWorkAtProject[]
}

type Actions =
    {type: 'SET_USER', payload: IGraphUser[]}|
    {type: 'SET_ROLES', payload: string[]}|
    {type: 'SET_SETTINGS', payload: Settings}|
    {type: 'SET_PROJECTS', payload: IWorkAtProject[]}|
    {type: 'SET_UNITS', payload: {main:IUnit[], secondary:IUnit[]}}|
    {type: 'REMOVE_UNIT', payload: IUnit}|
    {type: 'APPEND_UNIT', payload: IUnit}|
    {type: 'EDIT_UNIT', payload: IUnit}

const AppReducer: Reducer<State, Actions> = (state,action) => {
    switch (action.type) {
        case "SET_USER": return {
            ...state,
            user: action.payload
        }
        case "SET_ROLES": return {
            ...state,
            roles: action.payload
        }
        case "SET_UNITS": return {
            ...state,
            units: action.payload
        }
        case "SET_PROJECTS": return {
            ...state,
            projects: action.payload
        }
        case "REMOVE_UNIT":
            let stateMainUnitsCopy = state.units.main.concat();
            let stateSecUnitsCopy = state.units.main.concat();
            stateMainUnitsCopy = stateMainUnitsCopy.filter(x => x.id !== action.payload.id);
            stateSecUnitsCopy = stateSecUnitsCopy.filter(x => x.id !== action.payload.id);
            return {
                ...state,
                units: {
                    main: stateMainUnitsCopy,
                    secondary: stateSecUnitsCopy
                }
            }
        case "SET_SETTINGS": return {
            ...state,
            settings: action.payload
        }
        case "APPEND_UNIT":
            const units = {...state.units};
            if(action.payload.parent_unit) units.secondary.push(action.payload);
            else units.main.push(action.payload);
            return {
                ...state,
                units: units
            }
        case "EDIT_UNIT":
            const unitsAll = {...state.units};
            console.log(action.payload, unitsAll[action.payload.parent_unit ? 'secondary' : 'main'].find(x => x.id === action.payload.id));
            unitsAll[action.payload.parent_unit ? 'secondary' : 'main'] = unitsAll[action.payload.parent_unit ? 'secondary' : 'main'].filter(x => x.id !== action.payload.id);
            unitsAll[action.payload.parent_unit ? 'secondary' : 'main'].push(action.payload);
            return {
                ...state,
                units: unitsAll
            }
    }
}

export const AppContext = createContext<{
    state: State,
    dispatch: Dispatch<Actions>
}>({
    state: initialData,
    dispatch: (payload: Actions) => {}
});

export const AppProvider: FC = ({children}) => {
    const [state,dispatch] = useReducer(AppReducer, initialData);
    return (
        <AppContext.Provider value={{
            state,
            dispatch
        }}>{children}</AppContext.Provider>
    )
}